export default "__VITE_ASSET__daa2c6ed__"